import PropTypes from 'prop-types';
import React from 'react';

const NoPage = React.lazy(() => import('pages/NoPage.jsx'));

const FeaturedElement = ({ enabled, children }) => {
    if (!enabled) {
        return NoPage;
    }
    return children;
};

FeaturedElement.propTypes = {
    enabled: PropTypes.bool,
    children: PropTypes.node,
};

export default FeaturedElement;
